export default {
  computed: {
    dataBarCollection() {
      if (Object.keys(this.data).length) {
        return {
          labels: this.getLabels(),
          datasets: this.getDataSets(),
          databylables: this.getDataByLables()
        };
      }

      return {};
    }
  },
  methods: {
    // сбор данных по методу
    getDataSets() {
      if (this.showChartScale) {
        return this[this.chartScaleItems.items[this.chartScaleItems.active].dataMethod]();
      } else {
        return this.defaultData();
      }
    },
    getDataByDays(){
      return  [
        {
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.vk'),
          backgroundColor: "#4c75a3",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.vk ? this.data.vk.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "vk"
        },
        {/*
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.dz'),
          backgroundColor: "#7b8794",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.dz ? this.data.dz.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "dz"
      */},
        {
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.fb'),
          backgroundColor: "#3b5998",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.fb ? this.data.fb.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "fb"
        },
        {
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.tw'),
          backgroundColor: "#06cff1",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.tw ? this.data.tw.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "tw"
        },
        {
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.tg'),
          backgroundColor: "#fec72c",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.tg ? this.data.tg.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "tg"
        },
        {
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.ok'),
          backgroundColor: "#f6b500",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.ok ? this.data.ok.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "ok"
        },
        {
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.yt'),
          backgroundColor: "#c62828",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.yt ? this.data.yt.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "yt"
        },
        {
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.gs'),
          backgroundColor: "#7c17e1",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.gs ? this.data.gs.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "gs"
        }
      ].filter(item => this.socialList.includes(item.short));
    },
    // метод сбора данных по умолчанию
    defaultData() {
      return  [
        {
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.vk'),
          backgroundColor: "#4c75a3",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.vk ? this.data.vk.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "vk"
        },
        {/*
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.dz'),
          backgroundColor: "#7b8794",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.dz ? this.data.dz.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "dz"
      */},
        {
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.fb'),
          backgroundColor: "#3b5998",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.fb ? this.data.fb.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "fb"
        },
        {
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.tw'),
          backgroundColor: "#06cff1",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.tw ? this.data.tw.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "tw"
        },
        {
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.tg'),
          backgroundColor: "#fec72c",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.tg ? this.data.tg.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "tg"
        },
        {
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.yt'),
          backgroundColor: "#c62828",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.yt ? this.data.yt.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "yt"
        },
        {
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.ok'),
          backgroundColor: "#f6b500",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.ok ? this.data.ok.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "ok"
        },
        {
          label: this.$t('feed.analytics.dynamicBySource.shortcuts.gs'),
          backgroundColor: "#7c17e1",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data.gs ? this.data.gs.total.map(item => item[1]) : [],
          showLabel: this.showLabel,
          short: "gs"
        }
      ].filter(item => this.socialList.includes(item.short));
    },
    // сбор labels по методу
    getLabels() {
      if (this.showChartScale) {
        return this[this.chartScaleItems.items[this.chartScaleItems.active].labelMethod]();
      } else {
        return this.defaultLabels();
      }
    },
    getLabelsByDays() {
      return this.defaultLabels();
    },
    // метод сбора labels по умолчанию
    defaultLabels() {
      return this.data.total.total.map(item => {
        let dateSeparator = "-";

        if (item[0].includes(dateSeparator)) {
          let dateArr = item[0].split('-');
          let month = parseInt(dateArr[1]) - 1;

          return [item[0].slice(-2), this.month[month]];
        }

        return item[0];
      });
    },
    getDataByLables() {
      return this.data.vk.total.map((item, id) => {
        let dateSeparator = "-";

        if (item[0].includes(dateSeparator)) {
          let dateArr = item[0].split('-');
          let month = parseInt(dateArr[1]) - 1;
          return {
            category: item[0].slice(-2) + " " + this.month[month],
            vk: item[1],
            tg: this.data.tg.total[id][1],
            fb: this.data.fb.total[id][1],
            gs: this.data.gs.total[id][1],
            ig: this.data.ig.total[id][1],
            ok: this.data.ok.total[id][1],
            tw: this.data.tw.total[id][1],
            yt: this.data.yt.total[id][1],
            //dz: this.data.dz.total[id][1],
          };
        }
        return {
          category: item[0],
          vk: item[1],
          tg: this.data.tg.total[id][1],
          fb: this.data.fb.total[id][1],
          gs: this.data.gs.total[id][1],
          ig: this.data.ig.total[id][1],
          ok: this.data.ok.total[id][1],
          tw: this.data.tw.total[id][1],
          //dz: this.data.dz.total[id][1],

        };
      })
    }
  },
  data() {
    return {
      month: [
        'янв',
        'фев',
        'мар',
        'апр',
        'май',
        'июн',
        'июл',
        'авг',
        'сен',
        'окт',
        'ноя',
        'дек',
      ],
      endTime: '23:59:59',
      barOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            ticks: {
              padding: 10,
              pointStyle: "dote",
              fontSize: 10,
              fontFamily: "Roboto",
              fontStyle: "bold",
              fontColor: "rgb(179,188,204)",
              beginAtZero: true,
            },
            gridLines: {
              color: "rgb(179,188,204)",
              drawOnChartArea: false,
            }
          }],
          yAxes: [{
            barPercentage: 0.5,
            categoryPercentage: 0.3,
            ticks: {
              padding: 10,
              pointStyle: "dote",
              fontSize: 10,
              fontFamily: "Roboto",
              fontStyle: "bold",
              fontColor: "rgb(179,188,204)",
              beginAtZero: true
            },
            gridLines: {
              color: "rgb(179,188,204)",
              drawOnChartArea: false,
            }
          }],
        },
        legend: {
          display: true,
          position: "top",
          labels: {
            boxWidth: 7,
            usePointStyle: true
          }
        },
        plugins: {
          datalabels: {
            display: (ctx) => {
              return ctx.dataset.showLabel;
            },
            anchor: "end",
            color: "#000000",
            formatter: function(value, ctx) {
              if (value === 0) {
                return "";
              }
            },
            align: (ctx) => {
              if (ctx.dataset.data.length) {
                const index = ctx.dataIndex;
                const value = ctx.dataset.data[index];
                const max = ctx.chart.scales['y-axis-0'].max;
                const step = Math.round(max / ctx.dataset.data.length);

                //return value >= (max - step) ? "bottom" : "top";
                return "top"
              }
            },
            font: {
              weight: 'normal',
              size: 10,
              family: "Roboto",
            },
          },
          clamp: true,
          clip: true,
        },
        tooltips: {
          backgroundColor: '#ffffff',
          titleFontFamily: "Roboto",
          titleFontStyle: "normal",
          titleFontColor: "#5E6D82",
          bodyFontFamily: "Roboto",
          bodyFontColor: "#5E6D82",
          borderColor: "#b3bccc",
          borderWidth: 1
        },
        hover: {mode: null},
      },
    };
  },
};
